import analysts from './analysts'
import candidates from './candidates'
import common from './common'

export default {
  ...analysts,
  ...candidates,
  ...common
}
